export default function getErrorMessage(error, intl) {
  let message = '';

  if (intl.messages[`http.${error}`]) {
    message = intl.messages[`http.${error}`];
  } else {
    message = intl.messages[`http.api-error`];
  }

  return message;
}



// WEBPACK FOOTER //
// ./utils/getErrorMessage.js